/**
 * The moves a course switch carries over, as a URL parameter and back. Kept
 * apart from the switch rule so the trainer page can read it without
 * loading the rule's main lines.
 */
export const SWITCH_PARAM = "from";
export const encodeMoves = (sans: string[]) => sans.join(" ");
export function decodeMoves(raw: string | null): string[] {
  if (!raw || raw.length > 512) return [];
  const moves = raw.trim().split(/\s+/);
  return moves.length <= 29 &&
    moves.every((san) =>
      /^(?:O-O(?:-O)?|[KQRBN]?[a-h]?[1-8]?x?[a-h][1-8](?:=[QRBN])?)[+#]?$/.test(san)
    )
    ? moves
    : [];
}
